export const toClassName = (...values: (boolean | string | undefined)[]) => {
  return values.filter(Boolean).join(' ');
};

export const handleGenerateInitialsFromName = (name: string) => {
  let result = name;

  if (name) {
    result = name.charAt(0);
  }

  return result;
};

export const handleFormatDate = (date: string, t: any) => {
  const dateObject = new Date(date);
  return `${dateObject.getDate()} ${t(`enum.date.month.${dateObject.getMonth()}`)} ${dateObject.getFullYear()}`;
};

export const handleConvertToLocale = (lang: string) => {
  let result = lang;

  switch (lang) {
    case 'nl':
      result = 'nl-BE';
      break;
    case 'fr':
      result = 'fr-BE';
      break;
    case 'en':
      result = 'en';
      break;
  }

  return result;
};

export const formatDateToStringToCat = (dateObj: Date, t: any) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) return '';

  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  return `${t(`enum.day.${days[dateObj.getDay()]}`)} ${String(
    dateObj.getMonth() + 1,
  ).padStart(2, '0')}.${String(dateObj.getDate()).padStart(2, '0')}`;
};

export const convertDateToHHmm = (dateObj: Date) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj as any)) {
    console.error('Invalid input: Please provide a valid Date object.');
    return '';
  }

  const hours = `0${dateObj.getHours()}`.slice(-2);
  const minutes = `0${dateObj.getMinutes()}`.slice(-2);

  return `${hours}:${minutes}`;
};

export const handleGetFromDateFromPlayDates = (
  playDates:
    | {
        date?: string | undefined;
        location?: string | undefined;
        url?: string | undefined;
        _key: string;
      }[]
    | undefined,
) =>
  [...(playDates ?? [])]
    .map((playDate) => playDate.date)
    .filter((item) => item !== undefined)
    .sort((a, b) => (a < b ? -1 : 1))[0];

export const handleGetToDateFromPlayDates = (
  playDates:
    | {
        date?: string | undefined;
        location?: string | undefined;
        url?: string | undefined;
        _key: string;
      }[]
    | undefined,
) =>
  [...(playDates ?? [])]
    .map((playDate) => playDate.date)
    .filter((item) => item !== undefined)
    .sort((a, b) => (a > b ? -1 : 1))[0];

export const sortByDate = (
  items: any[],
  order: 'asc' | 'desc' = 'asc',
): any[] => {
  return [...items].sort((a, b) => {
    const dateA = a.date instanceof Date ? a.date : new Date(a.date);
    const dateB = b.date instanceof Date ? b.date : new Date(b.date);

    if (order === 'asc') {
      return dateA.getTime() - dateB.getTime();
    } else {
      return dateB.getTime() - dateA.getTime();
    }
  });
};
